import { Component, OnInit } from "@angular/core";
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2'

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {

  constructor(public _auth: AuthService) {}

  ngOnInit(): void {}

  logout() {
    Swal.fire({
      html:
        "<img class='logout-icon' src='assets/images/login/logout-icon.png'/>" +
        "<p>¿Estás seguro que deseas cerrar sesión?</p>",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      showClass: {
        popup: 'animated fadeIn fast'
      },
      hideClass: {
        popup: 'animated fadeOut fast'
      },
      customClass: {
        closeButton: 'close-button-class',
        confirmButton: 'confirm-button-class',
        cancelButton: 'cancel-button-class',
      }
    }).then((result) => {
      if (result.value) {
        this._auth.logout();
      }
    })
  }
}
